import React, { useEffect, useState, useRef } from 'react';
import {f7, Page, Link,  Button, Input, Icon, Popup } from "framework7-react";
import { Col, Form } from "react-bootstrap";
import axios from 'axios';
import { API_BASE_URL, API_AUTH, IMG_URL } from './../globals';

  const EditMenuPage = ({ f7route }) => {
    const {id} = f7route.params;
    const [data, setData] = useState({});
    const [dietary, setDietary] = useState([]);        
    const [imagefile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [items, setItemData] = useState([]);
    const [item, setItem] = useState({});
    const fileInputRef = useRef(null);
    const [MenuSize, setMenuSize] = useState([]);
    const [menuType, setMenuType] = useState([]);
    const [menutyp, setMenuTyp] = useState([]);
    const [familyZiseId, setFamilyZiseId] = useState(0);
    const [familyPrice, setFamilyPrice] = useState(0);
    const [editItemIndex, setEditItemIndexId] = useState(0);
    const handleImageChange = (event) => {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageFile(file);
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);      
      console.log(file);
    };
    const addMenuFamily = (event) => {
      event.preventDefault();
      const selectedSize = familyZiseId;
      const price = familyPrice;
      const selectedSizeName = event.target.elements.size.options[event.target.elements.size.selectedIndex].text; 
      const updatedItem = {
        ...item,
        menu_amount: price,
        menu_size_id: selectedSize,
        menu_size_name: selectedSizeName
      };
      const updatedItems = [...items, updatedItem];
      setItemData(updatedItems);
      f7.popup.close('.demo-popup');
      console.log(items);
    }
    const updateMenuFamily = (event) => {
      event.preventDefault();
      console.log(editItemIndex);
      
      const itemIndex = editItemIndex;
      console.log(itemIndex);
      const selectedSize = familyZiseId;
      const price = familyPrice;
      const selectedSizeName =  event.target.elements.size.options[event.target.elements.size.selectedIndex].text;
      const updatedItems = [...items];
      updatedItems[itemIndex] = {
        ...updatedItems[itemIndex],
        menu_amount: price,
        menu_size_id: selectedSize,
        menu_size_name: selectedSizeName
      };
      // console.log(updatedItems) 
      // const updatedItems = [updateItem];
      setItemData(updatedItems);
      f7.popup.close('.update-demo-popup');
    }
    const getImageAsBase64 = (imageUrl) => {
      if(imageUrl !==''){
        return new Promise((resolve, reject) => {
          fetch(imageUrl)
            .then((response) => response.blob())
            .then((blob) => {
              const reader = new FileReader();
              reader.onloadend = () => {
                const base64String = reader.result;
                resolve(base64String);
              };
              reader.onerror = reject;
              reader.readAsDataURL(blob);
            })
            .catch(reject);
        });
      }
    };
    useEffect(() => {
      axios.get(API_BASE_URL + 'dietary', {
        headers: {
          'Authorization': 'Basic ' + API_AUTH
        }
      })
      .then(response => {
        setDietary(response.data.data);
      })
      .catch(error => console.log(error));

      axios.get(API_BASE_URL + 'menutype', {
        headers: {
          'Authorization': 'Basic ' + API_AUTH
        }
      })
      .then(response => {
        setMenuTyp(response.data.data);
        console.log(response.data.data);
      })
      .catch(error => console.log(error));
      
      axios.get(API_BASE_URL + 'menu', {
          headers: {
            'Authorization': 'Basic ' + API_AUTH
          },
          params: {
            id: id,
            limits: 1
          }
        })
        .then(response => {
          setData(response.data[0]);
          console.log(response.data[0]);
          setItemData(response.data[0].menu_size);
          setMenuType(response.data[0].menu_type);
          const imageUrl = response.data[0].menu_item_picture;
        
          if (imageUrl) {
            getImageAsBase64(IMG_URL + imageUrl)
              .then(base64String => setImagePreview(base64String))
              .catch(error => console.log(error));
          } else {
            console.log('Image URL is null or empty');
            // You can set a default image or handle the null image case here if needed.
          }
        })
        .catch(error => console.log(error));

        axios.get(API_BASE_URL + 'menusize', {
          headers: {
            'Authorization': 'Basic ' + API_AUTH
          }
        })
        .then(response => {
          setMenuSize(response.data);
          
          console.log(response.data);
        })
        .catch(error => console.log(error));
    }, [id]);
    
    const menudata = {
      'menu_item_picture': imagePreview,
      'menu_item_name': data.menu_item_name,
      'menu_type': menuType,
      'menu_type_food': data.menu_type_food,
      'menu_item_desc': data.menu_item_desc,
      'menu_item_price': data.menu_item_price,
      'tray_size_id': data.tray_size_id,
      'rest_id': localStorage.getItem('id'),
      'menu_item_active': data.menu_item_active,
      'menu_size': items,
    };
    
    const handleDivClick = () => {
      fileInputRef.current.click();
    };
    const removeItem = (index) =>{
      const updatedProduct = [...items];
      const id = updatedProduct[index].id;
      if(id > 0){
        axios.delete(API_BASE_URL + 'menusizedel/id/'+id,{
          headers: {
            'Authorization': 'Basic ' + API_AUTH,
          }
      }) 
        .then((response) => {
        // Handle successful deletion response if needed
        console.log(response);
        })
        .catch((error) => {
        // Handle error if needed
        console.error(error);
        });
      };
      updatedProduct.splice(index, 1);
      setItemData(updatedProduct);
      console.log(items);
    }
    const editIem = (index) => {
      const updatedProduct = [...items];
      console.log(updatedProduct);
      
      const index_id = updatedProduct[index].id;
      
      const id = updatedProduct[index].menu_size_id;
      const price = updatedProduct[index].menu_amount;
      setFamilyZiseId(id);
      setFamilyPrice(price);
      setEditItemIndexId(index);
      console.log(index);
    }
    const handleSubmit = (event) => {
      event.preventDefault();
      console.log(menudata);
      if(!menudata.menu_size || menudata.menu_size.length <= 0){
        f7.toast.create({
          text: 'Please select menu items',
          position: 'top',
          cssClass: 'bg-color-red',
          closeTimeout: 3000
        }).open();
        return;
    }else{
      axios.put(API_BASE_URL + 'menu/id/'+ id, menudata, {
        headers: {
          'Authorization': 'Basic ' + API_AUTH,
         
        }
      })
      .then(response => { 
        if(response.data.status == 'success'){
          // f7.views.main.router.back();
          f7.views.main.router.navigate('/main/', {
            reloadAll: true
          });
          f7.tab.show('#tab-2');
          f7.toast.create({
          text: 'Menu Updated..!',
          position: 'top',
          cssClass: 'bg-color-teal',
          closeTimeout: 2000
          }).open()
        }else{
          f7.toast.create({
            text: 'Image Supported PNG,JPEG,JPG Format Only..!',
            position: 'top',
            cssClass: 'bg-color-red',
            closeTimeout: 2000
          }).open()
        }
        // f7.views.main.router.navigate('#tab-4');
        // f7.views.main.router.tabLink('#tab-4');
        // f7.tab.show('#tab-4');
         })
      .catch(error =>  f7.toast.create({
        text: 'Image Supported PNG,JPEG,JPG Format Only..!',
        position: 'top',
        cssClass: 'bg-color-red',
        closeTimeout: 2000
      }).open());
    }
  }
  
    return (
    <Page className='bg-white'>
      <div className="container container-table ">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <header className="section-t-space">
            <div className="container-lg custom-container p-0">
              <div className="header-panel">
                <Link href="#" back><Icon ios="material:keyboard_arrow_left" aurora="material:keyboard_arrow_left" md="material:keyboard_arrow_left" className='theme-dark' backLink="Back" ></Icon> <span className='text-dark d-none d-md-block'>Back</span></Link>
                <h2>Edit Menu</h2>
              </div>
            </div>
          </header>
          <section className="section-b-space">
            <div className="custom-container p-0">
              <form onSubmit={handleSubmit} className='auth-form profile-form'>
                <section>
                  <div className="custom-container p-0">
                    <div className="profile-img">
                      {/* <img className="img-fluid img" src="assets/images/icons/profile.png" alt="profile" />                   */}
                      <div className="image-upload-wrapper" onClick={handleDivClick}>
                        {imagePreview ? (
                            <div className="preview-image-wrapper">
                              <img src={imagePreview} alt="" className="img-fluid img"/>
                            </div>
                          ) : (
                            <div className="no-image-placeholder text-center">
                              <Icon material="photo_camera" size={44} />
                              <div>Tap to upload image</div>
                            </div>
                          )}
                        <input
                          type="file"
                          ref={fileInputRef}
                          accept="image/*"
                          onChange={handleImageChange}
                          style={{ display: "none" }}
                          onInput={(event) => setData({...data, menu_item_picture: event.target.value})}
                        />
                        </div>
                    </div>
                  </div>
                </section>
                <div className="form-group">
                  <label className="form-label fw-semibold">Item Name</label>
                  <div className="form-input mb-4">
                    <Input type="text" className="form-control" required validate pattern="*{3,50}" placeholder="Enter Item Name" value={data.menu_item_name} onInput={(event) => setData({...data, menu_item_name: event.target.value})}/>
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label fw-semibold">Item Description</label>
                  <div className="form-input mb-4">
                    <Input type="text" className="form-control" required validate pattern="*{3,255}" placeholder="Enter Item Name" value={data.menu_item_desc} onInput={(event) => setData({...data, menu_item_desc: event.target.value})}/>
                  </div>
                </div>
                {/* Family, Small, Medium, Large */}
                {/* <div className="form-group">
                  <label className="form-label fw-semibold">Available Sizes</label>
                  <div className="form-input mb-4">
                    <select className="form-select form-control" required validate>
                      <option value="1">Family</option>
                      <option value="2">Small</option>
                      <option value="3">Medium</option>
                      <option value="4">Large</option>
                    </select>
                  </div>
                </div> */}
                {/* <div className="form-group">
                  <label className="form-label fw-semibold">Price</label>
                  <div className="form-input mb-4">
                    <Input type="text" className="form-control" required validate pattern="[0-9]+([\.][0-9]{0,2})?" placeholder="Enter Item Name" value={data.menu_item_price} onInput={(event) => setData({...data, menu_item_price: event.target.value})}/>
                  </div>
                </div> */}
                {/* Diet (Vegan, Vegetarian, Keto, Palio etc.) - check boxes?  */}

                <div className="form-group">
                  <label className="form-label fw-semibold">Item Type</label>
                  <div className="form-input mb-4">
                    <select className="form-select form-control" value={data.menu_type_food} required placeholder="Please choose..." onChange={(event) => setData({...data, menu_type_food: event.target.value})}>
                    <option value="">Select Type</option>
                      {menutyp.map((item) => (
                        <option value={item.id}>
                          { item.name }
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label fw-semibold">Diet</label>
                  <div className="form-input mb-4">
                    <select className="form-select form-control" value={menuType} onChange={e => setMenuType([].slice.call(e.target.selectedOptions).map(item => item.value))} required validate multiple>
                    {dietary.map((item) => (
                        <option value={item.id}>
                          {item.dietary_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label fw-semibold">Status</label>
                  <div className="form-input mb-4">
                    <select className="form-select form-control" value={data.menu_item_active} onInput={(event) => setData({...data, menu_item_active: event.target.value})} required validate>
                      <option value="0">Active</option>
                      <option value="1">Inactive</option>
                      <option value="2">Give away</option>
                    </select>
                  </div>
                </div>
                <div className="form-group">
                <h3 className="fw-bold dark-text">Menu Price Details</h3>
                  <table className="table table-striped table-sm text-2 mt-2">
                    <tbody className='mt-2 '>
                      {items.map((items, index) => (              
                        <tr className='align-middle'>
                          <td width={'10%'} className='text-center'>{index +1}.</td>                
                          <td><h5 className="dark-text fw-bold mb-1 text-capitalize"> {items.menu_name}</h5>Type : {items.menu_size_name}, Price : <b>$ {items.menu_amount}</b><br/></td>
                          <td width={'10%'} className='text-center'><a href="#"  role="button"  onClick={() => editIem(index)}><Button popupOpen=".update-demo-popup"> <Icon material='edit' className='text-success'></Icon> </Button></a></td>
                          <td width={'10%'} className='text-center'><a href="#" role="button" onClick={() => removeItem(index)}> <Icon material='delete' className='text-danger'></Icon> </a></td>
                        </tr>                  
                      ))}

                </tbody>
                  </table>
                  <div class="title">
                    <h3 class="mt-0">Add Price</h3>
                    <a href="#"><Button fill small className="text-white btn-success filter-button mt-1 text-1" popupOpen=".demo-popup">Add Price</Button></a>
                  </div>
              </div> 
                <Button type="submit" className="btn theme-btn w-100 mt-0" large role="button">Update Menu</Button>
              </form>
              
            </div>
              
          </section>
          <Popup className="demo-popup custom-web">
            <Page>
              <div className="search-filter modal-dialog modal-fullscreen custom-web">
                <div className="modal-content">
                  <header className="section-t-space">
                    <div className="container-lg custom-container p-0">
                      <div className="header-panel">
                        <Link/>
                        <h2>Add Item Price</h2>
                        <Link className="btn-close" popupClose style={{marginRight: "15px"}}/>
                      </div>
                    </div>
                  </header>
                  <section className="section-b-space">
                    <div className="custom-container">
                      <form id="formAddCart" className="auth-form profile-form" onSubmit={addMenuFamily}>
                        <div className="form-group">
                          <div className="form-group">
                            {/* Family, Small, Medium, Large */}
                              <label className="form-label fw-semibold">Available Sizes</label>
                              <div className="form-input mb-4">
                                <select name="size" value={familyZiseId} onChange={(e)=>setFamilyZiseId(e.target.value)} className="form-select form-control" required validate>
                                <option >Select Menu Size</option>
                                  {MenuSize.map((item) => (
                                        <option value={item.id}>
                                          { item.name } ({item.size})
                                        </option>
                                      ))}
                                </select>
                              </div>
                          </div>
                          <div className="form-group">
                            <label className="form-label fw-semibold">$</label>
                            <div className="form-input mb-4">
                              <Input type="text" className="form-control"  value={familyPrice} onChange={(e) => setFamilyPrice(e.target.value)}name="price" required validate pattern="[0-9]+([\.][0-9]{0,2})?" placeholder="Enter Rate"/>
                            </div>
                          </div>
                          <Button type="submit" className="btn theme-btn w-100 mt-0" large role="button">Add Price</Button>
                        </div>        
                      </form>
                    </div>
                  </section>
                </div>
              </div>
            </Page>
          </Popup>
          <Popup className="update-demo-popup custom-web">
            <Page>
              <div className="search-filter modal-dialog modal-fullscreen custom-web">
                <div className="modal-content">
                  <header className="section-t-space">
                    <div className="container-lg custom-container p-0">
                      <div className="header-panel">
                        <Link/>
                        <h2>Update Item Price</h2>
                        <Link className="btn-close" popupClose style={{marginRight: "15px"}}/>
                      </div>
                    </div>
                  </header>
                  <section className="section-b-space">
                    <div className="custom-container">
                      <form id="formAddCart" className="auth-form profile-form" onSubmit={updateMenuFamily}>
                        <div className="form-group">
                          <div className="form-group">
                            {/* Family, Small, Medium, Large */}
                              <label className="form-label fw-semibold">Available Sizes</label>
                              <div className="form-input mb-4">
                                <select name="size" value={familyZiseId} onChange={(e)=>setFamilyZiseId(e.target.value)} className="form-select form-control" required validate>
                                <option >Select Menu Size</option>
                                  {MenuSize.map((item) => (
                                        <option value={item.id}>
                                          { item.name } ({item.size})
                                        </option>
                                      ))}
                                </select>
                              </div>
                          </div>
                          <div className="form-group">
                            <label className="form-label fw-semibold">$</label>
                            <div className="form-input mb-4">
                              <Input type="text" className="form-control"  value={familyPrice} onChange={(e) => setFamilyPrice(e.target.value)}name="price" required validate pattern="[0-9]+([\.][0-9]{0,2})?" placeholder="Enter Rate"/>
                            </div>
                          </div>
                          <Button type="submit" className="btn theme-btn w-100 mt-0" large role="button">Add Price</Button>
                        </div>        
                      </form>
                    </div>
                  </section>
                </div>
              </div>
            </Page>
          </Popup>
          </div>
        </div>
    </Page>
  );
};

export default EditMenuPage;
